export default "__VITE_ASSET__DnWuCDR___"